import { requestApi } from "../axios";

export function getAdInventoryList(appId, limit, offset, keyword, openTrash) {
  const keywordParam = keyword ? `&keyword=${encodeURIComponent(keyword)}` : "";
  return requestApi(
    `/retail-media/admin/ad-inventory?limit=${limit}&offset=${offset}&partner_app_id=${appId}&trash=${!!openTrash}${keywordParam}`,
  );
}

export function getAdInventoryWidgetData(appId) {
  return requestApi(`/retail-media/admin/ad-report/retailer/widget-list-inventory?partner_app_id=${appId}`);
}

export function createAdInventory(payload) {
  return requestApi(`/retail-media/admin/ad-inventory`, "POST", payload);
}

export function updateAdInventory(payload, id) {
  return requestApi(`/retail-media/admin/ad-inventory/${id}`, "PATCH", payload);
}

export function deleteAdInventory(id) {
  return requestApi(`/retail-media/admin/ad-inventory/${id}`, "DELETE");
}

export function toggleTrashStatus(payload) {
  return requestApi(`/retail-media/admin/ad-inventory/move-trash`, "POST", payload);
}

export function publishAdInventory(payload) {
  return requestApi(`/retail-media/admin/ad-inventory/publish`, "POST", payload);
}

export function getApprovalAds(appId, limit, offset, keyword, status) {
  const keywordParam = keyword ? `&keyword=${encodeURIComponent(keyword)}` : "";
  const statusParam = status ? `&status=${encodeURIComponent(status)}` : "";
  return requestApi(
    `/retail-media/admin/ad/list-ad-by-partner?limit=${limit}&offset=${offset}&partner_app_id=${appId}${keywordParam}${statusParam}`,
  );
}

export function getAdApprovalWidgetData(appId) {
  return requestApi(`/retail-media/admin/ad-report/retailer/widget-list-approval?partner_app_id=${appId}`);
}

export function approveAd(payload) {
  return requestApi(`/retail-media/admin/ad/approve`, "POST", payload);
}

export function rejectAd(payload) {
  return requestApi(`/retail-media/admin/ad/reject`, "POST", payload);
}

export function stopAdByRetailer(payload) {
  return requestApi(`/retail-media/admin/ad/stop`, "POST", payload);
}

export function getScreenCodeList(appId) {
  return requestApi(`/retail-media/admin/ad-inventory/list-screen-code?partner_app_id=${appId}`);
}

export function getAdvertiserList(limit, offset, keyword) {
  const keywordParam = keyword ? `&keyword=${encodeURIComponent(keyword)}` : "";
  return requestApi(`/retail-media/admin/advertiser?limit=${limit}&offset=${offset}${keywordParam}`);
}

export function createAdvertiser(payload) {
  return requestApi(`/retail-media/admin/advertiser`, "POST", payload);
}

export function updateAdvertiser(payload, id) {
  return requestApi(`/retail-media/admin/advertiser/${id}`, "PATCH", payload);
}

export function deleteAdvertiser(id) {
  return requestApi(`/retail-media/admin/advertiser/${id}`, "DELETE");
}

export function getAdCampaignList(id, limit, offset, keyword) {
  const keywordParam = keyword ? `&keyword=${encodeURIComponent(keyword)}` : "";
  return requestApi(`/retail-media/admin/ad-campaign?adv_id=${id}&limit=${limit}&offset=${offset}${keywordParam}`);
}

export function getCampaignWidgetData(id) {
  return requestApi(`/retail-media/admin/ad-report/advertiser/widget-list-campaign?adv_id=${id}`);
}

export function createAdCampaign(payload) {
  return requestApi(`/retail-media/admin/ad-campaign`, "POST", payload);
}

export function updateAdCampaign(payload, id) {
  return requestApi(`/retail-media/admin/ad-campaign/${id}`, "PATCH", payload);
}

export function deleteAdCampaign(id) {
  return requestApi(`/retail-media/admin/ad-campaign/${id}`, "DELETE");
}

export function getAdList(id, limit, offset, keyword, status) {
  const keywordParam = keyword ? `&keyword=${encodeURIComponent(keyword)}` : "";
  const statusParam = status ? `&status=${encodeURIComponent(status)}` : "";
  return requestApi(
    `/retail-media/admin/ad?ad_campaign_id=${id}&limit=${limit}&offset=${offset}${keywordParam}${statusParam}`,
  );
}

export function getAdWidgetData(id) {
  return requestApi(`/retail-media/admin/ad-report/advertiser/widget-list-ad?ad_campaign_id=${id}`);
}

export function createAd(payload) {
  return requestApi(`/retail-media/admin/ad`, "POST", payload);
}

export function getAdById(id) {
  return requestApi(`/retail-media/admin/ad/${id}`);
}

export function publishAd(id) {
  return requestApi(`/retail-media/admin/ad/send-approve/${id}`, "POST");
}

export function updateAd(payload, id) {
  return requestApi(`/retail-media/admin/ad/${id}`, "PATCH", payload);
}

export function stopAdByAdvertiser(payload) {
  return requestApi(`/retail-media/admin/ad/stop-by-advertiser`, "POST", payload);
}

export function toggleAdByAdvertiser(payload) {
  return requestApi(`/retail-media/admin/ad/advertiser/pause-start-ad`, "POST", payload);
}

export function deleteAd(id) {
  return requestApi(`/retail-media/admin/ad/${id}`, "DELETE");
}

export function getProductList(advertiserId, limit, offset, keyword) {
  const keywordParam = keyword ? `&keyword=${encodeURIComponent(keyword)}` : "";
  return requestApi(
    `/retail-media/admin/product?adv_id=${advertiserId}&limit=${limit}&offset=${offset}${keywordParam}`,
  );
}

export function createProduct(payload) {
  return requestApi(`/retail-media/admin/product`, "POST", payload);
}

export function updateProduct(payload, id) {
  return requestApi(`/retail-media/admin/product/${id}`, "PATCH", payload);
}

export function deleteProduct(id) {
  return requestApi(`/retail-media/admin/product/${id}`, "DELETE");
}

export function getDataWidgetAdCampaign(campaignId, from, to) {
  return requestApi(
    `/retail-media/admin/ad-report/advertiser/widget-campaign?campaign_id=${campaignId}&start_date=${from}&end_date=${to}`,
  );
}

export function getDataChartAdCampaignClick(campaignId, adId, from, to) {
  return requestApi(
    `/retail-media/admin/ad-report/advertiser/click-ad-campaign?campaign_id=${campaignId}&ad_id=${adId}&start_date=${from}&end_date=${to}`,
  );
}

export function getDataChartAdCampaignGMV(campaignId, adId, from, to) {
  return requestApi(
    `/retail-media/admin/ad-report/advertiser/gmv-ad-campaign?campaign_id=${campaignId}&ad_id=${adId}&start_date=${from}&end_date=${to}`,
  );
}

export function getDataChartAdCampaignCost(campaignId, adId, from, to) {
  return requestApi(
    `/retail-media/admin/ad-report/advertiser/cost-ad-campaign?campaign_id=${campaignId}&ad_id=${adId}&start_date=${from}&end_date=${to}`,
  );
}

export function getSankeyChartData(campaignId, adId, from, to) {
  return requestApi(
    `/retail-media/admin/ad-report/advertiser/sankey-chart?campaign_id=${campaignId}&ad_id=${adId}&start_date=${from}&end_date=${to}`,
  );
}

export function getStatisticRetailer(appId, from, to, adType) {
  return requestApi(
    `/retail-media/admin/ad-report/widget-for-retailer?ad_partner_app_id=${appId}&start_date=${from}&end_date=${to}&ad_type=${adType}`,
  );
}

export function getDataChartClickRetailer(appId, from, to, adType) {
  return requestApi(
    `/retail-media/admin/ad-report/click-for-retailer?ad_partner_app_id=${appId}&start_date=${from}&end_date=${to}&ad_type=${adType}`,
  );
}

export function getDataChartRevenueShareRetailer(appId, from, to, adType) {
  return requestApi(
    `/retail-media/admin/ad-report/revenue-sharing-for-retailer?ad_partner_app_id=${appId}&start_date=${from}&end_date=${to}&ad_type=${adType}`,
  );
}

export function getDataStockProductChart(advertiserId, orderType) {
  return requestApi(`/retail-media/admin/product/chart-stock?adv_id=${advertiserId}&order_type=${orderType}`);
}

export function getDataPriceProductChart(advertiserId) {
  return requestApi(`/retail-media/admin/product/chart-price?adv_id=${advertiserId}`);
}

export function getDataRevenueRatioRetailer(appId, from, to, adType) {
  return requestApi(
    `/retail-media/admin/ad-report/revenue-ratio-for-retailer?ad_partner_app_id=${appId}&start_date=${from}&end_date=${to}&ad_type=${adType}`,
  );
}
export function getDataSankeyRetailer(appId, from, to, adType) {
  return requestApi(
    `/retail-media/admin/ad-report/sankey-chart-for-retailer?ad_partner_app_id=${appId}&start_date=${from}&end_date=${to}&ad_type=${adType}`,
  );
}
export function getBannerList(advertiserId, limit, offset, keyword) {
  const keywordParam = keyword ? `&keyword=${encodeURIComponent(keyword)}` : "";
  return requestApi(`/retail-media/admin/banner?adv_id=${advertiserId}&limit=${limit}&offset=${offset}${keywordParam}`);
}

export function createBanner(payload) {
  return requestApi(`/retail-media/admin/banner`, "POST", payload);
}

export function updateBanner(payload, id) {
  return requestApi(`/retail-media/admin/banner/${id}`, "PATCH", payload);
}

export function removeBanner(id) {
  return requestApi(`/retail-media/admin/banner/${id}`, "DELETE");
}

export function getDataInteractiveProductChart(payload) {
  return requestApi(`/retail-media/admin/product/chart-most-interaction`, "POST", payload);
}

export function getDataRevenueProductChart(payload) {
  return requestApi(`/retail-media/admin/product/chart-revenue`, "POST", payload);
}

export function getDataInteractiveBannerChart(payload) {
  return requestApi(`/retail-media/admin/banner/chart-most-interaction`, "POST", payload);
}

export function duplicateAd(payload) {
  return requestApi(`/retail-media/admin/ad/duplicate`, "POST", payload);
}

/* ----------------------------- Ad Revision ----------------------------- */

// Detail of the original ad together with its open revision (used for the compare modal).
// Returns the open DRAFT/REJECTED revision object, or null when none exists.
export function getAdDetailWithRevision(adId) {
  return requestApi(`/retail-media/admin/ad/${adId}/detail-with-revision`);
}

// Advertiser: save a draft revision (keyed by adId). Backend creates the DRAFT if none exists.
export function updateAdRevision(payload, adId) {
  return requestApi(`/retail-media/admin/ad/advertiser/revision/${adId}`, "PATCH", payload);
}

// Advertiser: delete a DRAFT or REJECTED revision (keyed by adId; original ad keeps running).
export function deleteAdRevision(adId) {
  return requestApi(`/retail-media/admin/ad/advertiser/revision/${adId}`, "DELETE");
}

// Advertiser: send the revision for retailer approval (keyed by adId; DRAFT -> WAITING).
// Backend creates the DRAFT (if needed), saves the body, then submits in one step.
export function sendApproveAdRevision(adId, payload) {
  return requestApi(`/retail-media/admin/ad/advertiser/revision/${adId}/send-approve`, "POST", payload);
}

// Retailer: approve a revision (merges into the original ad without interrupting it).
export function approveAdRevision(revisionId) {
  return requestApi(`/retail-media/admin/ad/revision/${revisionId}/approve`, "POST");
}

// Retailer: reject a revision (original ad keeps running).
export function rejectAdRevision(revisionId, payload) {
  return requestApi(`/retail-media/admin/ad/revision/${revisionId}/reject`, "POST", payload);
}

// Optional: version history of an ad.
export function getAdHistory(adId) {
  return requestApi(`/retail-media/admin/ad/${adId}/history`);
}
